import { Container, ContainerHeader, ContainerContent } from 'components/Containers/Containers'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { Button, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'

export const Scope = ({ setStep, setState, state }: { setStep: (step: number) => void, setState?: any, state: any }) => {


    const handleSelect = () => null

    const handleNext = () => setStep(3)
    const handleBack = () => setStep(1)

    return <>


        <Container>
            <ContainerHeader>
                <TitleText>Org Scope</TitleText>
            </ContainerHeader>
            <ContainerContent>
                <Flex gap='1rem'>
                    <HonestSelectAsyncInput
                        nomarg
                        link='locations'
                        placeholder='Search locations'
                        name='fromLocation'
                        labelText='From Location'
                        defaultValue={state?.fromLocation?.label}
                        onChange={handleSelect}
                        parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.name, value: i.id }))}
                    />
                    <HonestSelectAsyncInput
                        nomarg
                        link='departments'
                        placeholder='Search department'
                        name='department'
                        labelText='Department'
                        defaultValue={state?.department?.label}
                        onChange={handleSelect}
                        parserFunction={(data: any) =>
                            data.data.map((i: any) => ({ label: i.name, value: i.id }))
                        }
                    />
                </Flex>
                <HonestSelectAsyncInput
                    nomarg
                    link='users/basic'
                    name='owner'
                    labelText='Owner'
                    onChange={handleSelect}
                    defaultValue={state.owner?.label}
                    parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.fullName, profilePictureUrl: i.getImagePresignedUrl, value: i.id, id: i.accessCardId, role: i.role, gender: i.gender, tierPolicy: i.currentContract?.logisticsInfo?.accomodationTierPolicy }))}
                />

            </ContainerContent>
        </Container>
        <Flex gap='1rem' mt='32' justend>
            <Button onClick={handleBack}>Back</Button>
            <Button orange onClick={handleNext} >Next</Button>
        </Flex>
    </>
}